import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import CardMedia from '@material-ui/core/CardMedia';

const fallbackThumbnail = '/media/info-center/thumbnail-placeholder.svg';

const cardMediaCss = css`
  &.MuiCardMedia-root {
    position: relative;
    /* https://css-tricks.com/aspect-ratio-boxes/ */
    height: 0;
    padding-top: 56.25%;
  }
`;

function PromoMedia({ children, thumbnailUrl, className }) {
  return (
    <CardMedia
      className={className}
      css={cardMediaCss}
      image={thumbnailUrl ?? fallbackThumbnail}
    >
      {children}
    </CardMedia>
  );
}

PromoMedia.propTypes = {
  children: PropTypes.node,
  thumbnailUrl: PropTypes.string,
  className: PropTypes.string,
};

export default PromoMedia;
